var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { height: "60%" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("h4", { staticClass: "cursive" }, [_vm._v("Date flessibili")]),
              _vm._v(" "),
              _c("p", { staticClass: "m-0" }, [
                _vm._v(
                  "Valuta le altre date di partenza e trova la soluzione alle tue esigenze di viaggio"
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "modal-flexible-date container" }, [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "alert alert-danger" }, [
              _c("p", { staticClass: "mb-0" }, [
                _c("b", [_vm._v("Attenzione!")]),
                _vm._v(
                  " Se si seleziona un nuovo range di date l'itinerario sarà cancellato"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items" },
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item",
                    class: item.selected ? "item selected" : "item",
                    attrs: { value: item },
                    on: {
                      click: function($event) {
                        return _vm.onSelect(item)
                      }
                    }
                  },
                  [
                    _c("div", [
                      !item.selected
                        ? _c(
                            "h3",
                            {
                              class:
                                _vm.makeDeltaPrice(item.prezzoVendita) > 0
                                  ? "more"
                                  : "minus"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.sign(item.prezzoVendita)) +
                                  _vm._s(_vm.abs(item.prezzoVendita)) +
                                  " €"
                              )
                            ]
                          )
                        : _c("h3", [_vm._v("Date selezionate")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-around" },
                      [
                        _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getDayExtended(item.start)))
                          ]),
                          _vm._v(" "),
                          _c("h2", [_vm._v(_vm._s(_vm.getDay(item.start)))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.getMonth(item.start)))])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getDayExtended(item.end)))
                          ]),
                          _vm._v(" "),
                          _c("h2", [_vm._v(_vm._s(_vm.getDay(item.end)))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.getMonth(item.end)))])
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7525917f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7525917f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/volo-hotel/modals/ModalFlexibleDates.vue
// module id = null
// module chunks = 